import React, {
    useCallback,
    useEffect,
    useRef,
} from "react";
import { Form, Row, Col, Typography, Button as AntdButton, Tag } from "antd";
import { Button } from "components/Buttons/Buttons";
import Modal from "components/Modal/Modal";
import {
    FormDatePicker,
    FormHiddenSubmitButton,
    FormInput,
    FormInputArea,
    FormInputNumber,
} from "components/FormItems/FlatFormItems";
import { useForm } from "antd/lib/form/Form";
import { FormSelect } from "components/FormItems/FlatFormItems";
import moment from "moment";
import {
    EXCLUSION_TYPE,
} from "utils/enums";
import { useDispatch, useSelector } from "react-redux";
import {
    getProgramById,
} from "services/programsAndMembership.services";
import { createEarningPoint, getEarningPoint, updateEarningPoint } from "services/earningPoints.service";

const { Title } = Typography;


const exclusionTypes = Object.entries(EXCLUSION_TYPE).map((it) => {
    return {
        label: it[0],
        value: it[1],
    };
});

function EarningPointsAddEditModal({
    services, isServicessLoading, addons, isAddOnsLoading,
    categories,
    isCategoriesLoading,
    data = {},
    visible,
    onCancel,
    onSuccess,
    taxCategories = [],
}) {
    // props destruct start
    // props destruct end

    // hooks that bring data start
    const submitRef = useRef();
    const dispatch = useDispatch();
    // hooks that bring data end

    // states start

    // states end

    const { allFacilities, isFetchingFacilities } = useSelector(
        (state) => state.facilities
    );
    // hooks that dont bring data start
    const [form] = useForm();

    const productIds = Form.useWatch("productIds", form);
    const categoryIds = Form.useWatch("categoryIds", form);
    const productExcludeType = Form.useWatch("productExcludeType", form);
    const facilityExcludeType = Form.useWatch("facilityExcludeType", form);
    const categoryExcludeType = Form.useWatch("categoryExcludeType", form);



    const isEdit = data?.loyaltyPolicyId;

    const loadData = () => {
        dispatch(getEarningPoint(data?.loyaltyPolicyId)).then((res) => {
            if (res?.status === "success") {
                form.setFieldsValue({
                    ...res?.data,
                    fromDate: res?.data?.fromDate
                        ? moment(res?.data?.fromDate)
                        : undefined,
                    tillDate: res?.data?.tillDate
                        ? moment(res?.data?.tillDate)
                        : undefined,
                });

            }
        });
    };




    useEffect(() => {
        if (visible && data?.loyaltyPolicyId) {
            form.setFieldsValue({
                ...data,
                fromDate: data?.fromDate ? moment(data?.fromDate) : undefined,
                tillDate: data?.tillDate ? moment(data?.tillDate) : undefined,
            });
            loadData();
        } else {
            form.resetFields();
        }
    }, [visible]);





    // handleSubmit
    const handleSubmit = useCallback(
        async (values) => {
            console.log('values: ', values)
            let submittableValues = { ...values }
            submittableValues.fromDate = values?.fromDate?.format("YYYY-MM-DD");
            submittableValues.tillDate = values?.tillDate?.format("YYYY-MM-DD");

            let result = null;
            if (isEdit) {
                submittableValues.loyaltyPolicyId = data.loyaltyPolicyId;
                result = await dispatch(updateEarningPoint(data.loyaltyPolicyId, submittableValues))
            } else {
                result = await dispatch(createEarningPoint(submittableValues))
            }

            if (result?.status === "success") {
                onSuccess?.(submittableValues);
            }
        },
        [data, isEdit, onSuccess]
    );

    const filteredProducts = React.useMemo(() => {
        let productsByCategory = []
        // if all categories are included, then show all products
        if (categoryExcludeType === EXCLUSION_TYPE["All Included"]) {
            productsByCategory = services
        } else if (categoryExcludeType === EXCLUSION_TYPE["All Include Except"]) {
            productsByCategory = services.filter((service) => {
                return !service.productCategoryIds?.some(categoriesId => categoryIds?.includes(categoriesId))
            })
        } else if (categoryExcludeType === EXCLUSION_TYPE["Only Included"]) {
            // if some categories are included, then show only products from those categories
            productsByCategory = services.filter((service) => {
                return service.productCategoryIds?.find(categoriesId => categoryIds?.includes(categoriesId))
            })
        }
        // if some categories are included, then show only products from those categories

        const filtered = productsByCategory?.filter((it) => {
            return (
                it?.isActive || productIds?.includes?.(it?.productId)
            );
        }) || []

        console.log("filtered products: ", filtered, "categoryExcludeType: ", categoryExcludeType, "categoryIds: ", categoryIds, "productIds: ", productIds, "services: ", services)

        // include addons that belong to any of the filtered services
        const addonIds = new Set(filtered.flatMap((it) => it?.addOnIds || []))
        const addonsByProducts = addons?.filter((addon) => addonIds.has(addon?.productId)) || []
        console.log("addonsByProducts: ", addonsByProducts, "addonIds: ", addonIds, "addons: ", addons)

        return [...filtered, ...addonsByProducts]
    }, [services, addons, categoryExcludeType, categoryIds, productIds]);


    return (
        <Modal
            className="ant-modal-title-tradeGothic"
            //   closable={closable}
            destroyOnClose={true}
            //   headerBorder={false}
            width="720px"
            title="Add/Edit Earning Points"
            onCancel={() => onCancel()}
            visible={visible}
            onOk={() => console.log("ok")}
            okText="Add"
            centered={true}
            footer={
                <div className="d-flex justify-between align-center">
                    <AntdButton
                        type="text"
                        onClick={() => { }}
                        style={{ padding: 0 }}
                    >
                        Cancel
                    </AntdButton>
                    <Button
                        style={{ height: 50 }}
                        rounded={true}
                        onClick={() => { submitRef.current?.click?.() }}

                    //   disabled={!Boolean(setupIntent)}
                    >
                        Submit
                    </Button>
                </div>
            }
        //   cancelText="No"
        >
            <Form
                form={form}
                initialValues={{
                    facilityExcludeType: 1,
                    categoryExcludeType: 1,
                    productExcludeType: 1,
                }}
                layout="vertical"
                requiredMark={false}
                onFinishFailed={({ values, errorFields, outOfDate }) => {
                    console.log(errorFields);
                    form.scrollToField(errorFields[0].name, {
                        scrollMode: "if-needed",
                        block: "center",
                        behavior: "smooth",
                    });
                }}
                onFinish={handleSubmit}
                preserve={true}
            >

                <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                        <FormInput
                            variant="underlined"
                            name="name"
                            label={"Earning Points Name"}
                            placeholder={"Earning Points Name"}
                            required={true}
                            formItemStyles={{
                                margin: 0,
                            }}
                        />
                    </Col>
                    <Col xs={12} >
                        <FormInputNumber
                            variant="underlined"
                            name="pointsPerDollar"
                            label="Points Per Dollar"
                            placeholder="Points Per Dollar"
                            formItemStyles={{
                                marginBottom: 0,
                            }}
                            rules={
                                [
                                    {
                                        required: true,
                                    },
                                    {
                                        message: "Must be greater than 0",
                                        validator: (_, value) => {
                                            if (value <= 0) {
                                                return Promise.reject();
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]
                            }

                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <FormSelect
                            variant="underlined"
                            name="facilityExcludeType"
                            label="Facility Exclusion Type"
                            placeholder="Select exclusion type"
                            formItemStyles={{ marginBottom: 0 }}
                            options={exclusionTypes}
                            // isOptionDisabled={(it) => !it.isActive}
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            renderLabel="label"
                            renderValue="value"
                            required
                        />
                    </Col>
                    <Col xs={24} sm={12}>
                        <FormSelect
                            mode={"multiple"}
                            feedBack={false}
                            variant="underlined"
                            name="facilityIds"
                            loading={isFetchingFacilities}
                            label="Facilities"
                            renderValue="facilityId"
                            placeholder={"Select Facilities"}
                            renderLabel="facilityName"
                            formItemStyles={{ marginBottom: 0 }}
                            // formItemStyles={{ marginBottom: 12 }}
                            options={allFacilities?.filter((it) => it?.isActive)}
                            optionLabelProp="label"
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            disabled={
                                facilityExcludeType === EXCLUSION_TYPE["All Included"]
                            }
                            required={
                                facilityExcludeType !== EXCLUSION_TYPE["All Included"]
                            }
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <FormSelect
                            variant="underlined"
                            name="categoryExcludeType"
                            label="Category Exclusion Type"
                            placeholder="Select exclusion type"
                            formItemStyles={{ marginBottom: 0 }}
                            options={exclusionTypes}
                            // isOptionDisabled={(it) => !it.isActive}
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            renderLabel="label"
                            renderValue="value"
                            required
                            onChange={() => {
                                // clear cascading dropdowns
                                form.setFieldsValue({
                                    categoryIds: [],
                                    productExcludeType: EXCLUSION_TYPE["All Included"],
                                    productIds: [],
                                })
                            }}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <FormSelect
                            variant="underlined"
                            name="categoryIds"
                            label="Categories"
                            placeholder="Select categories"
                            mode="multiple"
                            formItemStyles={{ marginBottom: 0 }}
                            options={categories?.filter((it) => {
                                return (
                                    it?.isActive || categoryIds?.includes?.(it?.categoryId)
                                );
                            })}
                            // isOptionDisabled={(it) => !it.isActive}
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            renderLabel="categoryName"
                            renderValue="categoryId"
                            disabled={
                                categoryExcludeType === EXCLUSION_TYPE["All Included"]
                            }
                            required={
                                categoryExcludeType !== EXCLUSION_TYPE["All Included"]
                            }
                            loading={isCategoriesLoading}
                            onChange={() => {
                                // clear selected products
                                // set selected product exclusion type to all
                                form.setFieldsValue({
                                    productIds: [],
                                })
                            }}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <FormSelect
                            variant="underlined"
                            name="productExcludeType"
                            label="Product Exclusion Type"
                            placeholder="Select exclusion type"
                            formItemStyles={{ marginBottom: 0 }}
                            options={exclusionTypes}
                            // isOptionDisabled={(it) => !it.isActive}
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            renderLabel="label"
                            renderValue="value"
                            required
                            onChange={() => {
                                // clear cascading dropdown
                                form.setFieldsValue({
                                    productIds: [],
                                })
                            }}
                        />
                    </Col>
                    {/* )} */}
                    <Col xs={24} md={12}>
                        <FormSelect
                            variant="underlined"
                            name="productIds"
                            label="Services"
                            placeholder="Select services"
                            mode="multiple"
                            formItemStyles={{ marginBottom: 0 }}
                            options={filteredProducts}
                            // isOptionDisabled={(it) => !it.isActive}
                            filterOption={(input, option) => {
                                return option?.label
                                    ?.toLowerCase?.()
                                    .includes?.(input.toLowerCase());
                            }}
                            renderLabel="productName"
                            renderValue="productId"
                            disabled={
                                productExcludeType === EXCLUSION_TYPE["All Included"]
                            }
                            required={
                                productExcludeType !== EXCLUSION_TYPE["All Included"]
                            }
                            loading={isServicessLoading || isAddOnsLoading}
                        />
                    </Col>

                    <Col xs={24} md={12}>
                        <FormDatePicker
                            form={form}
                            // disabled={isAppointmentFormDisabled}
                            name="fromDate"
                            label="Start Date"
                            variant="underlined"
                            formItemStyles={{ marginBottom: 0 }}
                            disabledDate={(current) =>
                                current.isBefore(moment().subtract(1, "day"))
                            }
                            required
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <FormDatePicker
                            validateFirst
                            form={form}
                            // disabled={isAppointmentFormDisabled}
                            name="tillDate"
                            label="End Date"
                            variant="underlined"
                            formItemStyles={{ marginBottom: 0 }}
                            disabledDate={(current) =>
                                current.isBefore(moment().subtract(1, "day"))
                            }
                            rules={[
                                {
                                    required: false,
                                    message: "Required",
                                },
                                {
                                    message: "Start and End Date cannot be same",
                                    validator: (_, value) => {
                                        const startDate = form.getFieldValue("fromDate");
                                        const endDate = form.getFieldValue("tillDate");

                                        if (!endDate) {
                                        } else if (
                                            startDate?.format?.("DD-MM-YYYY") ===
                                            endDate?.format?.("DD-MM-YYYY")
                                        ) {
                                            return Promise.reject();
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        />
                    </Col>
                    <Col xs={24}>
                        <Title
                            variant={5}
                            style={{
                                margin: 0,
                                fontSize: 16,
                                color: "#161F3A",
                                marginBottom: 12,
                            }}
                        >
                            Description
                        </Title>
                        <FormInputArea
                            name={"notes"}
                            variant="underlined"
                            formItemStyles={{ width: "100%", margin: 0 }}
                        />
                    </Col>
                </Row>
                <FormHiddenSubmitButton submitRef={submitRef} />
            </Form>

        </Modal>
    );
}

EarningPointsAddEditModal.propTypes = {};

export default EarningPointsAddEditModal;
